import { SelectOption } from "../../../types/select";
import { numberWithCommas } from "./components/utils";

export const torRulesOption = [
  {
    label: "Base Rent Only",
    value: "baseRentOnly",
  },
  {
    label: "Turnover Rent Only",
    value: "turnoverRentOnly",
  },
  {
    label: "Base Rent + Turnover Rent",
    value: "baseRentAndTurnoverRent",
  },
  {
    label: "Base Rent or Turnover (Higher of)",
    value: "baseRentOrTurnoverRent",
  },
];

type TorSets = {
  allTorValues: Set<string>;
  turnoverAllowedTorValues: Set<string>;
};

export function generateTorRulesSets(torOptions: SelectOption[]): TorSets {
  const allTorValues = new Set<string>();
  const turnoverAllowedTorValues = new Set<string>();

  for (const option of torOptions) {
    allTorValues.add(option.value);
    if (option.value !== "baseRentOnly") {
      turnoverAllowedTorValues.add(option.value);
    }
  }

  return { allTorValues, turnoverAllowedTorValues };
}

export const torRulesTypeOption = [
  {
    label: "Flat",
    value: "or",
  },
  {
    label: "Tiered",
    value: "and",
  },
];

export const defaultRule = {
  torPercent: 0,
  minSale: 0,
  maxSale: 0,
  uptoLimit: 1,
  minLimit: 0,
  torRuleCondition: {
    label: "Flat",
    value: "or",
  },
};

export const hasTorRules = (formTorType?: string): boolean => {
  const isValidTor = (torType?: string) => !!torType && torType !== "baseRentOnly" && torType !== "";

  return isValidTor(formTorType);
};

export const vatInPercentage = (totlaAmount = 0,atualAmount = 0) => {
  let vat = 100 * (totlaAmount / atualAmount - 1);
  let toFixed: any = vat > 0 ? Number(vat)?.toFixed(2) : 0;
  return numberWithCommas(toFixed || 0);
};
